import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcChevronRight20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m7 15.006c0 .53.431.994.995.994.266 0 .531-.133.697-.298l5.01-5.006c.198-.199.298-.464.298-.696 0-.265-.1-.53-.299-.696l-5.01-5.006c-.164-.198-.429-.298-.695-.298a.998.998 0 0 0 -.996.994c0 .266.1.53.299.73l4.28 4.276-4.28 4.276c-.2.2-.299.464-.299.73z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcChevronRight20;
